import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-remark-model',
  templateUrl: './remark-model.component.html'
})
export class RemarkModelComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
